import { ISuggestionItem } from 'telia-front-react';

export const CALLS_AND_MESSAGES_SERVICE_GROUP_ID = 2;
export const INTERNET_SERVICE_GROUP_ID = 3;
export const CALLBACK_SERVICE_ID = 66;
export const MOBILE_INTERNET_SERVICE_ID = 69;
export const NO_MOBILE_INTERNET_SERVICE_AVAILABLE_ID = 0;

export interface Country {
  name: string;
  isoCode: string;
  eea: boolean;
}

export interface Package {
  serviceShortName: string;
  isoCode: string;
  price: string;
  priceWithVAT: string;
  volume: string;
  estKeywords: string[];
  rusKeywords: string[];
  engKeywords: string[];
}

export interface Operator {
  id: string;
  name: string;
  url: string;
  shortName: string;
  network: string;
  networkType: string;
  operatorCodes: string[];
  operatorCodesOnBill: string[];
  openNetworks: string[];
  coverageMap: string;
  infoOnGsm: string;
  intInfo: string;
  operatorServiceGroups: ServiceGroup[];
  comment: string;
}

export interface ServiceGroup {
  id: number;
  name: string;
  adsrvServices: AdsrvService[];
  groupServices: GroupService[];
  groupRateTimes: GroupNote[];
  groupNotes: GroupNote[];
}

export interface AdsrvService {
  name: string;
}

export interface GroupService {
  id: number;
  name: string;
  servicePrices: ServicePrices[];
}

export interface GroupNote {
  notePrompt: string;
}

export interface ServicePrices {
  priceValueWoVat: string;
  priceUnit: string;
  currency: string;
  priceValue: string;
  priceTimeName: string;
}

export interface CountrySuggestion extends ISuggestionItem {
  synonym: string;
}

export interface NumberSuggestion extends ISuggestionItem {
  synonym: string;
}

export interface ServicePrice {
  priceType: string;
  servCode: string;
  servName: string;
  price: number;
  priceWithKM: number;
  interval: number;
  brand: string;
}

export interface PriceByPrefix extends ServicePrice {
  isoCode: string;
  country: string;
  eea: boolean;
}

export interface CountryWithPrices {
  name: string;
  isoCode: string;
  callingCode: string;
  prices: ServicePrice[];
  fromPrefix: boolean;
  searchTerm: string;
  eea: boolean;
}

export interface BerecInformation {
  emergencyNumbers: EmergencyNumber[];
  pwsNumbers: PwsNumber[];
  vasNumbers: VasNumber[];
  countryCode: string;
}

interface BerecNumber {
  additionalInformation: string;
}

export interface EmergencyNumber extends BerecNumber {
  meansOfAccess: string;
  emDescription: string;
  downloadLink: string;
}

export interface PwsNumber extends BerecNumber {
  pwsMeansOfAccess: string;
  typeOfPws: string;
  linkToPwsDescription: string;
  linkToPwsDownload: string;
}

export interface VasNumber extends BerecNumber {
  vasNumberRange: string;
  nameDescription: string;
}
